
export const categories = [
  {
    id: 1,
    name: "Airport",
    icon: `${process.env.PUBLIC_URL}/image/icons/AirportIcon.png`,
    count: 1,
    path: "https://www.pgparks.com/facilities/college-park-airport",
    description: "World’s oldest continually operated airport."
  },
  {
    id: 2,
    name: "Aquatic Facilities",
    icon: `${process.env.PUBLIC_URL}/image/icons/AquiticFacilitiesIcon.png`,
    count: 13,
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?facility%5B%5D=aquatics",
    description: "Indoor and outdoor swimming pools and splash parks."
  },
  {
    id: 3,
    name: "Arts Centers",
    icon: `${process.env.PUBLIC_URL}/image/icons/ArtsCentersIcon.png`,
    count: 5,
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?facility%5B%5D=art-center",
    description: "Facilities dedicated to visual and performing arts."
  },
  {
    id: 4,
    name: "Boxing Center",
    icon: `${process.env.PUBLIC_URL}/image/icons/BoxingCentersIcon.png`,
    count: 1,
    path: "https://www.pgparks.com/facilities/sugar-ray-leonard-amateur-boxing-center",
    description: "Boxing training and event facilities."
  },
  {
    id: 5,
    name: "Community Centers",
    icon: `${process.env.PUBLIC_URL}/image/icons/CommunityCentersIcon.png`,
    count: "45",
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?facility%5B%5D=community-center",
    description: "Facilities with community events, classes, and programs."
  },
  {
    id: 6,
    name: "Equestrian Center",
    icon: `${process.env.PUBLIC_URL}/image/icons/EquestrianCenterIcon.png`,
    count: 1,
    path: "https://www.pgparks.com/facilities/showplace-arena-at-pgs-equestrian-center",
    description: "Facilities for horseback riding and training."
  },
  {
    id: 7,
    name: "Golf Centers",
    icon: `${process.env.PUBLIC_URL}/image/icons/GolfCenterIcon.png`,
    count: 4,
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?title=golf",
    description: "Public golf courses and practice areas."
  },
  {
    id: 8,
    name: "Historical Sites",
    icon: `${process.env.PUBLIC_URL}/image/icons/HistoricalVenuesIcon.png`,
    count: 18,
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?facility=historical-site&amenity=&renttype=",
    description: "Sites of historical and cultural importance."
  },
  {
    id: 9,
    name: "Ice Rinks",
    icon: `${process.env.PUBLIC_URL}/image/icons/IceRinksIcon.png`,
    count: "2",
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?facility%5B%5D=ice-rink",
    description: "Indoor ice skating rinks."
  },
  {
    id: 10,
    name: "Rental Spaces",
    icon: `${process.env.PUBLIC_URL}/image/icons/MeetingSpacesIcon.png`,
    count: "25+",
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?amenity%5B%5D=meeting-room",
    description: "Facilities with rentable rooms for meetings and events."
  },
  {
    id: 11,
    name: "Museums",
    icon: `${process.env.PUBLIC_URL}/image/icons/MuseumIcon.png`,
    count: 9,
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?facility%5B%5D=museum",
    description: "Public museums with exhibits and educational programs."
  },
  {
    id: 12,
    name: "Nature Centers",
    icon: `${process.env.PUBLIC_URL}/image/icons/NatureCenterIcon.png`,
    count: 4,
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?facility%5B%5D=nature-centers",
    description: "Facilities focused on nature education and exploration."
  },
  {
    id: 13,
    name: "Park Buildings",
    icon: `${process.env.PUBLIC_URL}/image/icons/ParkBuildingsIcon.png`,
    count: 18,
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?facility%5B%5D=park",
    description: "Facilities available to be rented for small, private events."
  },
  {
    id: 14,
    name: "Regional Parks",
    icon: `${process.env.PUBLIC_URL}/image/icons/RegionalCenterIcon.png`,
    count: 3,
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?title=regional",
    description: "Large parks serving broad geographic regions."
  },
  {
    id: 15,
    name: "Senior Activity Centers",
    icon: `${process.env.PUBLIC_URL}/image/icons/SeniorsIcon.png`,
    count: 8,
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?facility%5B%5D=senior-activity-center",
    description: "Facilities with programs exclusively for senior citizens."
  },
  {
    id: 16,
    name: "Sports",
    icon: `${process.env.PUBLIC_URL}/image/icons/SportsIcon.png`,
    count: "20+",
    path: "https://www.pgparks.com/activities-events/sports",
    description: "Facilities for various indoor and outdoor sports."
  },
  {
    id: 17,
    name: "Trap & Skeet Center",
    icon: `${process.env.PUBLIC_URL}/image/icons/SkeetIcon.png`,
    count: 1,
    path: "https://www.pgparks.com/facilities/prince-georges-trap-and-skeet-center",
    description: "Facility for trap and skeet shooting."
  },
  {
    id: 18,
    name: "Waterfront Parks",
    icon: `${process.env.PUBLIC_URL}/image/icons/WaterfrontParksIcon.png`,
    count: 6,
    path: "https://www.pgparks.com/parks-trails/park-finder?amenity%5B%5D=waterfront",
    description: "Parks located along waterfronts and shorelines."
  },
  {
    id: 19,
    name: "Campgrounds",
    icon: `${process.env.PUBLIC_URL}/image/icons/CampgroundIcon.png`,
    count: 4,
    path: "https://www.pgparks.com/parks-trails/park-finder?amenity%5B%5D=camp-ground",
    description: "Designated park areas for overnight camping and outdoor recreation"
  },
  {
    id: 20,
    name: "Playgrounds",
    icon: `${process.env.PUBLIC_URL}/image/icons/PlaygroundIcon.png`,
    count: "245+",
    path: "https://www.pgparks.com/parks-trails/park-finder?amenity%5B%5D=play-equipment",
    description: "Park areas with play equipment designed for children’s recreation."
  },
  {
    id: 21,
    name: "Picnic Shelters",
    icon: `${process.env.PUBLIC_URL}/image/icons/PicnicShelterIcon.png`,
    count: "130+",
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?amenity%5B%5D=picnic-shelters",
    description: "Covered park structures available for picnics and group gatherings."
  },
  {
    id: 22,
    name: "Dog Parks",
    icon: `${process.env.PUBLIC_URL}/image/icons/DogParkIcon.png`,
    count: 8,
    path: "https://www.pgparks.com/parks-trails/park-finder?amenity%5B%5D=dog-park",
    description: "Designated park areas where dogs can exercise off-leash.",
  },
  {
    id: 23,
    name: "Dinosaur Park",
    icon: `${process.env.PUBLIC_URL}/image/icons/DinosaurParkIcon.png`,
    count: 1,
    path: "https://www.pgparks.com/parks-trails/park-finder?title=Dinosaur",
    description: " A themed park featuring dinosaur exhibits and educational displays."
  },
  {
    id: 24,
    count: 4,
    name: "Archery Ranges",
    icon: `${process.env.PUBLIC_URL}/image/icons/ArcheryRangeIcon.png`,
    path: "https://www.pgparks.com/parks-trails/park-finder?amenity%5B%5D=archery",
    description: "Designated park facilities for practicing archery."
  },
  {
    id: 25,
    name: "Athletic Complexes",
    icon: `${process.env.PUBLIC_URL}/image/icons/AthleticComplexIcon.png`,
    count: 3,
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?facility=sports-complex&amenity=&renttype=Sports%20Complexes",
    description: "Multi-field facilities offering spaces for organized sports, tournaments, and recreational play."
  },
  {
    id: 26,
    name: "Parks",
    icon: `${process.env.PUBLIC_URL}/image/icons/ParkIcon.png`,
    count: "370+",
    path: "https://www.pgparks.com/parks-trails/park-finder",
    description: "Public green spaces providing recreation, relaxation, and connections to nature for the community."
  },
  {
    id: 27,
    name: "Miles of Trails",
    icon: `${process.env.PUBLIC_URL}/image/icons/MilesOfTrailsIcon.png`,
    count: "160+",
    path: "https://www.pgparks.com/parks-trails/trail-finder",
    description: "An interconnected network of trails for walking, running, biking, and enjoying the outdoors."
  },
   {
    id: 28,
    name: "Swimming Pools",
    icon: `${process.env.PUBLIC_URL}/image/icons/AquiticFacilitiesIcon.png`,
    count: 13,
    path: "https://www.pgparks.com/facilities-rentals/facilityfinder?facility%5B%5D=aquatics",
    description: "Indoor and outdoor swimming pools and splash parks."
  },

].sort((a, b) => a.name.localeCompare(b.name));

